// Modify header & footer pdf
import { useContext } from "react"
import { Card, FooterMenu, HeaderMenu } from "../../../../components"
import { Render, RenderProvider } from "./utils"
import { ChildItem } from "./components"
import { LinkAccountContext, LinkAccountProvider } from "pages/Setup/contexts"
import { exportPdf } from "utils"
import { dataAccountLinkSales } from "./utils/vars"
import { PdfLinkAccount } from "../components"
import { exportExcel } from "./utils/functions"

export default function LinkAccountSales() {
  return (
    <RenderProvider>
      <LinkAccountProvider>
        <section className="container pt-5  gap-5 flex flex-col">
          <HeaderMenu title="LINK ACCOUNT SALES" />

          <Card>
            <Card.Body>
              <div className="overflow-x-auto">
                <TableContent />
              </div>
            </Card.Body>
          </Card>
          <Footer />
        </section>
      </LinkAccountProvider>
    </RenderProvider>
  )
}

function TableContent() {
  const { render } = useContext(Render)

  if (render) {
    return <ChildItem />
  } else {
    return <div />
  }
}

function Footer(): JSX.Element {

  const { data } = useContext(LinkAccountContext)

  return (
    <FooterMenu
      export={{
        actiontype: "export",
        onClick: () => exportExcel({
          dataHeader: dataAccountLinkSales,
          data
        })
      }}
      pdf={{
        actiontype: "pdf",
        onClick: () => {
          exportPdf({
            documentComponent: <PdfLinkAccount
              dataLinkAccount={dataAccountLinkSales}
              dataList={data}
              title="Link Account Sales"
            />,
            fileName: "Link Account Sales"
          })
        }
      }}
    />
  )
}